/* ============================================================
   OSTUFF — os-core.js (v2 conversion, slimmed).
   Phase-1 removed the effects (scramble, follower cursor, hover-arming, halo, voice). Their
   per-cell measuring/arming machinery is gone too — it scaled with the number of cells and was the
   shop's main-thread cost. What remains and is still read cross-file : OS.core.RM (reduced-motion
   flag, used by os-nav / os-contact). Accordions moved to os-product (PDP only). Kept minimal.
   ============================================================ */
(function () {
  'use strict';
  var RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  window.OS = window.OS || {};
  window.OS.core = { RM: RM };
})();
